(() => {
  if (window.sentopiaInstagramShowcase) return;
  window.sentopiaInstagramShowcase = true;
  function init(root) {
    if (root.dataset.ready) return;
    const cards = [...root.querySelectorAll('.sp-reel-card')];
    if (!cards.length) return;
    const rail = root.querySelector('.sp-video-rail');
    const config = JSON.parse(root.querySelector('[data-gift-config]').textContent);
    const toggle = root.querySelector('[data-reel-toggle]');
    const count = root.querySelector('.sp-reel-count');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const lifecycle = new AbortController();
    const opts = { signal: lifecycle.signal };
    const videos = cards.map(card => card.querySelector('video'));
    let index = 0, visible = false, paused = config.reelAuto === false, manual = false;
    let timer = 0, pointer = null, dragged = false, keyboardFocus = false;
    const allowed = () => !motion.matches && !navigator.connection?.saveData;
    const playing = () => visible && !document.hidden && !paused && (manual || allowed());
    function load(video) {
      const source = video.querySelector('source[data-reel-src]');
      if (!source) return;
      source.src = source.dataset.reelSrc;
      source.removeAttribute('data-reel-src');
      video.load();
    }
    function syncPlayback() {
      videos.forEach((video, i) => {
        if (i !== index || !playing()) {
          video.pause();
          return;
        }
        load(video);
        if (!video.paused) return;
        video.play().then(() => {
          if (i !== index || !playing()) video.pause();
        }).catch(() => cards[i].classList.remove('is-playing'));
      });
      toggle.setAttribute('aria-label', paused ? config.reelLabels.resume : config.reelLabels.pause);
      toggle.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
      toggle.setAttribute('aria-pressed', String(paused));
    }
    function schedule() {
      clearTimeout(timer);
      if (!playing() || !allowed() || manual || keyboardFocus || pointer || cards.length < 2 || window.Shopify?.designMode) return;
      timer = setTimeout(() => select(index + 1), Math.max(5, Number(config.reelInterval) || 8) * 1000);
    }
    function render() {
      const half = Math.floor(cards.length / 2);
      cards.forEach((card, i) => {
        let offset = (i - index + cards.length) % cards.length;
        if (offset > half) offset -= cards.length;
        card.style.setProperty('--offset', offset);
        card.style.setProperty('--depth', Math.abs(offset));
        const hidden = Math.abs(offset) > 2;
        card.setAttribute('aria-hidden', String(hidden));
        card.inert = hidden;
        card.classList.toggle('is-active', i === index);
        const button = card.querySelector('[data-video-play]');
        button.tabIndex = hidden ? -1 : 0;
        button.setAttribute('aria-pressed', String(i === index));
      });
      count.textContent = (index + 1) + ' / ' + cards.length;
      root.dataset.activeIndex = index;
      syncPlayback();
      schedule();
    }
    function select(next) {
      index = (next + cards.length) % cards.length;
      manual = false;
      videos.forEach((video, i) => {
        video.controls = false;
        video.muted = true;
        cards[i].querySelector('[data-video-play]').hidden = false;
      });
      render();
    }
    cards.forEach((card, i) => {
      const video = videos[i];
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.addEventListener('play', () => card.classList.add('is-playing'), opts);
      video.addEventListener('pause', () => card.classList.remove('is-playing'), opts);
      card.querySelector('[data-video-play]').addEventListener('click', () => {
        if (dragged) { dragged = false; return; }
        if (i !== index) { paused = false; select(i); return; }
        manual = true;
        paused = false;
        video.controls = true;
        card.querySelector('[data-video-play]').hidden = true;
        syncPlayback();
        schedule();
      }, opts);
    });
    root.addEventListener('click', event => {
      const direction = event.target.closest('[data-reel-direction]');
      if (direction) {
        cards.forEach(card => { card.querySelector('[data-video-play]').hidden = false; });
        select(index + Number(direction.dataset.reelDirection));
      }
      if (event.target.closest('[data-reel-toggle]')) {
        paused = !paused;
        manual = !allowed();
        keyboardFocus = false;
        syncPlayback();
        schedule();
      }
    }, opts);
    rail.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      select(index + (event.key === 'ArrowRight' ? 1 : -1));
    }, opts);
    rail.addEventListener('pointerdown', event => {
      if (event.button !== 0 || event.target.closest('video[controls]')) return;
      pointer = { x: event.clientX, y: event.clientY };
      dragged = false;
      clearTimeout(timer);
    }, opts);
    window.addEventListener('pointerup', event => {
      if (!pointer) return;
      const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
      pointer = null;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
        dragged = true;
        select(index + (dx < 0 ? 1 : -1));
      } else schedule();
    }, opts);
    rail.addEventListener('pointercancel', () => { pointer = null; schedule(); }, opts);
    root.addEventListener('focusin', event => { keyboardFocus = event.target.matches(':focus-visible'); schedule(); }, opts);
    root.addEventListener('focusout', event => { keyboardFocus = root.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'); schedule(); }, opts);
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
      syncPlayback();
      schedule();
    }, { threshold: [0, .25] });
    observer.observe(rail);
    document.addEventListener('visibilitychange', () => { syncPlayback(); schedule(); }, opts);
    motion.addEventListener('change', () => { syncPlayback(); schedule(); }, opts);
    document.addEventListener('shopify:block:select', event => {
      const selected = cards.findIndex(card => card.dataset.reelId === event.detail.blockId);
      if (selected >= 0) select(selected);
    }, opts);
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      clearTimeout(timer);
      observer.disconnect();
      videos.forEach(video => video.pause());
      lifecycle.abort();
    }, opts);
    root.dataset.ready = 'true';
    root.querySelector('.sp-reel-controls').hidden = cards.length < 2;
    render();
  }
  function boot() { document.querySelectorAll('[data-instagram-showcase]').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
